import { render, staticRenderFns } from "./DailyMenyComponent.vue?vue&type=template&id=114e2b34&scoped=true&"
import script from "./DailyMenyComponent.vue?vue&type=script&lang=js&"
export * from "./DailyMenyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114e2b34",
  null
  
)

export default component.exports